import React, { FC } from 'react'
import { GetServerSideProps } from 'next'
import { LayoutProps } from '@sport1/types/web'
import StandardLayout from '@/layouts/Standard'
import { getSport1Navigation } from '@/pages/api/cms/navigation'
import { NavigationData } from '@/utils/navigation/Standard/types/NavigationItem'
import PageContentLayout from '@/layouts/Standard/PageContentLayout'
import { getLayoutByModeAndSlug, getTagBySlug } from '@/pages/api/cms/content/tag/[id]'
import extendMediathekPlaylist from '@/utils/seo/extendMediathekPlaylist'
import handleRejection from '@/utils/errors/handleRejection'
import useMediathekPaging from '@/hooks/useMediathekPaging'

type Props = {
    layoutData: LayoutProps
    navigation?: NavigationData
}
const Index: FC<Props> = ({ layoutData, navigation }) => {
    const { layout } = useMediathekPaging({
        layoutData,
        isPlaylistPage: true,
    })
    return (
        <StandardLayout navigation={navigation} mainContenMaxWidth={1572}>
            <PageContentLayout layoutData={layout} />
        </StandardLayout>
    )
}
export const getServerSideProps: GetServerSideProps<Props> = async ctx => {
    const slugArray = (ctx.query.slug as string[]) || []
    const layoutSlug = `/${slugArray.join('/')}`
    let navigationData, tag, playlistTag, layoutData

    try {
        ;[navigationData, tag, playlistTag] = await Promise.all([
            await getSport1Navigation(),
            getTagBySlug('/tv-video'),
            getTagBySlug(layoutSlug),
        ])
        layoutData = await getLayoutByModeAndSlug(
            layoutSlug,
            ctx.req.url?.includes('highlights') ? 'HIGHLIGHTS' : 'VIDEO'
        )
    } catch (error) {
        return handleRejection(error, { layoutSlug, slugArray })
    }

    extendMediathekPlaylist(layoutData, playlistTag.title)

    if (tag.navigationItems && tag.navigationItems.length > 0) {
        // TODO: What should we do when two layout urls should map to the same url. For now we hardcode the href by ourselves
        tag.navigationItems[0].href = '/tv-video'
    }

    const deeplink = `sport1://weburl/www.sport1.de/tv-video/playlisten${layoutSlug}`
    ctx.res.setHeader('deeplink', deeplink)
    return {
        props: {
            layoutData,
            deeplink,
            navigation: { ...navigationData, tag, breadCrumbs: { pageTitle: playlistTag.title } },
        },
    }
}
export default Index
